import { render, staticRenderFns } from "./WordCardsLessonPart.vue?vue&type=template&id=04a58b17&scoped=true&"
import script from "./WordCardsLessonPart.vue?vue&type=script&lang=js&"
export * from "./WordCardsLessonPart.vue?vue&type=script&lang=js&"
import style0 from "./WordCardsLessonPart.vue?vue&type=style&index=0&id=04a58b17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a58b17",
  null
  
)

export default component.exports